module.exports = __webpack_public_path__ + "img/footer_icon_facebook.74abf9da.svg";